import { trackException } from 'helpers/errorTracker';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { setUser } from '../../../actions/userActions';
import { networksSelector } from '../../../redux/selectors';
import usePageHook from '../../../hooks/usePageHook';
import { useUpdateUserMutation } from '../../../services/user';
import { legalDocumentsVersion } from '../../../settings/legalDocumentsVersion';

export const useOnboarding = () => {
  const { networks, active } = useSelector(networksSelector);
  const [updateUser, { isLoading: isLoadingUpdateUser }] = useUpdateUserMutation();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();

  usePageHook('Onboarding');

  const setOnboardingComplete = (user) => {
    const { avatarUrl, firstName, lastName, password } = user;
    const options = {
      avatarUrl,
      firstName,
      lastName,
      password,
      passwordConfirmation: password,
      onboardingCompleted: true,
      termsPolicyVersion: legalDocumentsVersion.termsPolicyVersion,
      privacyPolicyVersion: legalDocumentsVersion.privacyPolicyVersion,
    };

    return updateUser(options)
      .then((response) => {
        dispatch(
          setUser({
            avatarUrl,
            firstName,
            lastName,
            onboardingCompleted: true,
          }),
        );

        return response;
      })
      .catch((error) => {
        trackException(error);

        throw error;
      });
  };

  return { activeNetwork: networks[active], networks, path, isLoadingUpdateUser, setOnboardingComplete };
};
